module.exports = __webpack_public_path__ + "static/img/faq_service07.bca3e76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/faq_service07.png
// module id = iDaZ
// module chunks = 2